import styled from 'styled-components';

const processValue = (val) => {
  if (typeof val === 'number') {
    return `${val}px`;
  }

  return val;
};

export default styled.span`
  position: absolute;
  background: #4a4a4a;
  color: white;
  padding: 4px;
  top: ${(props) => `calc(${-props.bottomEdge}px - 50%)`};
  border-radius: 3px;
  font-family: 'Open Sans', sans-serif;
  width: 600px;
  max-width: max-content;
  white-space: normal;
  z-index: 999999;
  line-height: normal;
  ${(props) => (props.left ? `left: ${processValue(props.left)};` : '')}
  ${(props) => (props.right ? `right: ${processValue(props.right)};` : '')}
  ${(props) =>
    props.topArrow
      ? `&:after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #4a4a4a transparent;

  }`
      : ''}
`;
